// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"70143f10","329":"98d67140","482":"63989c87","787":"ee19a0d8"}[chunkId] + ".chunk.js";
};